import { render } from "./SupportModal.vue?vue&type=template&id=0521a2c8"
import script from "./SupportModal.vue?vue&type=script&lang=js"
export * from "./SupportModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/components/SupportModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0521a2c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0521a2c8', __exports__)) {
    api.reload('0521a2c8', __exports__)
  }
  
  module.hot.accept("./SupportModal.vue?vue&type=template&id=0521a2c8", () => {
    api.rerender('0521a2c8', render)
  })

}


export default __exports__